var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lcsj-dialog',{attrs:{"title":"报销单详情","width":"1200px","append-to-body":"","cancel-text":"关闭"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('detail',{ref:"detail"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }